<script setup lang="ts"></script>

<template>
  <div
    class="p-1 sm:p-3 rounded-lg sm:rounded-xl bg-secondary/30 border border-dashed border-divider/60 min-h-[68px] sm:min-h-[148px]"
  ></div>
</template>
